/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import { DEFAULT_LANGUAGE, type SupportedLanguage } from '../../utils/language.utils';
import { useTranslation } from '../../hooks/useTranslation';
import { PaginationView, type PaginationViewProps } from './PaginationView';

export interface PaginationProps extends Omit<PaginationViewProps, 'labels' | 'showPageSizeSelect'> {
    language?: SupportedLanguage;
    onPageSizeChange: (pageSize: number) => void;
}

/** Core locale adapter; every consumer renders the same presentation component. */
export const Pagination: React.FC<PaginationProps> = ({ language = DEFAULT_LANGUAGE, ...props }) => {
    const t = useTranslation(language);
    return <PaginationView {...props} labels={{
        perPage: t.common.perPage,
        firstPage: t.common.firstPage,
        previousPage: t.common.previousPage,
        nextPage: t.common.nextPage,
        lastPage: t.common.lastPage,
    }} />;
};
